import type { CurrencyModel } from "../viewModels/Settings/CurrencyModel";

export default function convertFromBaseCurrency(amount: number, baseCurrencyId: number, targetCurrency: CurrencyModel) {
  if (!Number.isFinite(amount)) return undefined;
  if (targetCurrency.id === baseCurrencyId) return amount;

  if (
    targetCurrency.baseCurrencyId !== baseCurrencyId ||
    !Number.isFinite(targetCurrency.rate) ||
    targetCurrency.rate <= 0 ||
    !Number.isFinite(targetCurrency.nominal) ||
    targetCurrency.nominal <= 0
  ) {
    return undefined;
  }

  const convertedAmount = (amount * targetCurrency.nominal) / targetCurrency.rate;
  return Number.isFinite(convertedAmount) ? convertedAmount : undefined;
}
